module.exports = __webpack_public_path__ + "static/media/fireball.800d8a91.png";